import ctiProfile from './firms/cti/profile.json'
import ctiDiscount from './firms/cti/discount.json'

import ttpProfile from './firms/ttp/profile.json'
import ttpDiscount from './firms/ttp/discount.json'

import e8Profile from './firms/e8/profile.json'
import e8Discount from './firms/e8/discount.json'

import fxifyProfile from './firms/fxify/profile.json'
import fxifyDiscount from './firms/fxify/discount.json'

import alphaProfile from './firms/alpha-capital/profile.json'
import alphaDiscount from './firms/alpha-capital/discount.json'

import forTradersProfile from './firms/for-traders/profile.json'
import forTradersDiscount from './firms/for-traders/discount.json'

import seacrestProfile from './firms/seacrest-funded/profile.json'
import seacrestDiscount from './firms/seacrest-funded/discount.json'


export const propFirmData = {
  cti: {
    ...ctiProfile,
    evaluation: {
      ...ctiProfile.evaluation,
      discount: ctiDiscount
    }
  },
  ttp: {
    ...ttpProfile,
    evaluation: {
      ...ttpProfile.evaluation,
      discount: ttpDiscount
    }
  },
  e8: {
    ...e8Profile,
    evaluation: {
      ...e8Profile.evaluation,
      discount: e8Discount
    }
  },
  fxify: {
    ...fxifyProfile,
    evaluation: {
      ...fxifyProfile.evaluation,
      discount: fxifyDiscount
    }
  },
  'alpha-capital': {
    ...alphaProfile,
    evaluation: {
      ...alphaProfile.evaluation,
      discount: alphaDiscount
    }
  },
  'for-traders': {
    ...forTradersProfile,
    evaluation: {
      ...forTradersProfile.evaluation,
      discount: forTradersDiscount
    }
  },
  'seacrest-funded': {
  ...seacrestProfile,
  evaluation: {
    ...seacrestProfile.evaluation,
    discount: seacrestDiscount
    }
  }

}
